"use client";

import {
	RiComputerLine,
	RiMoonLine,
	RiSmartphoneLine,
	RiSunLine,
} from "@remixicon/react";
import { cn } from "@workspace/ui/lib/utils";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

interface TopNavThemeProps {
	isAtTop?: boolean;
}

export function TopNavTheme({ isAtTop = false }: TopNavThemeProps) {
	const { theme, setTheme } = useTheme();
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkIfMobile = () => {
			setIsMobile(window.innerWidth < 768);
		};

		checkIfMobile();

		window.addEventListener("resize", checkIfMobile);

		return () => window.removeEventListener("resize", checkIfMobile);
	}, []);

	return (
		<div className="flex gap-1">
			<button
				type="button"
				onClick={() => setTheme("light")}
				className={cn(
					"flex flex-1 items-center justify-center p-1.5 transition-all duration-200",
					isAtTop ? "rounded-sm rounded-tl-xl" : "rounded-sm",
					theme === "light"
						? "bg-secondary"
						: "hover:bg-muted active:scale-[0.98] active:bg-muted/80",
				)}
				aria-label="Light theme"
			>
				<RiSunLine className="h-4 w-4" />
			</button>
			<button
				type="button"
				onClick={() => setTheme("dark")}
				className={cn(
					"flex flex-1 items-center justify-center rounded-sm p-1.5 transition-all duration-200",
					theme === "dark"
						? "bg-secondary"
						: "hover:bg-muted active:scale-[0.98] active:bg-muted/80",
				)}
				aria-label="Dark theme"
			>
				<RiMoonLine className="h-4 w-4" />
			</button>
			<button
				type="button"
				onClick={() => setTheme("system")}
				className={cn(
					"flex flex-1 items-center justify-center p-1.5 transition-all duration-200",
					isAtTop ? "rounded-sm rounded-tr-xl" : "rounded-sm",
					theme === "system"
						? "bg-secondary"
						: "hover:bg-muted active:scale-[0.98] active:bg-muted/80",
				)}
				aria-label="System theme"
			>
				{isMobile ? (
					<RiSmartphoneLine className="h-4 w-4" />
				) : (
					<RiComputerLine className="h-4 w-4" />
				)}
			</button>
		</div>
	);
}
